export default "__VITE_ASSET__BYa$EgtN__"